import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { AppointmentModel } from "app/services/api/types/calendar/models/AppointmentModel";
import { format } from "date-fns";
import { useMemo } from "react";
import { Text, Pressable, View } from "react-native";
import { Button, ButtonIcon } from "ui/gluestack/button";
import { CloseIcon, EditIcon, Icon } from "ui/gluestack/icon";

interface Props {
  appointment: AppointmentModel;
  occurrenceDate?: Date | null;
  onEdit?: () => void;
  onClose?: () => void;
}

export const EventViewHeader = ({
  appointment,
  occurrenceDate,
  onEdit,
  onClose,
}: Props) => {
  const title = useMemo(() => {
    const startDate =
      occurrenceDate ||
      (!appointment.is_recurring ? appointment.starts_at : "");
    return `${appointment.title || ""}${startDate ? format(startDate, ` 'on' dd MMMM ''yy`) : ""}`;
  }, [appointment, occurrenceDate]);
  return (
    <View className="pb-2 border-b border-border-200 ">
      <View className="flex flex-row  justify-between lg:gap-x-14 gap-x-10 items-center">
        <Text className="text-typography-900 font-semibold text-xl">
          {title}
        </Text>

        <View className="flex-row gap-x-3 h-fit ">
          <PermissionCheck permission={PermissionsEnums.UPDATE_CALENDAR_EVENT}>
            <Button
              action="primary"
              size="sm"
              variant="link"
              onPress={onEdit}
              className="px-2"
            >
              <ButtonIcon as={EditIcon} />
            </Button>
          </PermissionCheck>
          <Pressable onPress={onClose} className="justify-center">
            <Icon as={CloseIcon} className="w-6 h-6" />
          </Pressable>
        </View>
      </View>
    </View>
  );
};
